export const isTerpelTenant = () => {
  const theme = localStorage.getItem('theme');

  return !!theme?.includes('terpel');
};
